import React, { useEffect, createElement } from 'react';
import { ArrowRight, Check, ShieldCheck, Clock, BookOpen, Users } from 'lucide-react';
import { TestimonialCard } from '../components/TestimonialCard';
import { PurchasePopup } from '../components/PurchasePopup';
// Images
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/raAfGexmH14hiY6WCh2LEC/MOCK_UP_PRINCIPAL_TDAH-removebg-preview.png';
const BONUS_1 = 'https://cdn.magicpatterns.com/uploads/1E4h6JbkTVfhRWo9aeUCgj/ROADMAP_DE_PROGRESO.jpg';
const BONUS_2 = 'https://cdn.magicpatterns.com/uploads/86HosvMHgj2GqV83Gs6XXb/GUIA_PARA_PADRES.jpg';
const BONUS_3 = 'https://cdn.magicpatterns.com/uploads/jn7AJg76GhS4ZXDsKFaBKJ/BANCO_DE_ACTIVIDADES_POR_NIVEL_DE_ENERGIA.jpg';
// Purchase Link
const PURCHASE_LINK = 'https://checkout.ebookditales.com/cart/42817755185215:1';
export function LandingPage() {
  // Meta Pixel initialization
  useEffect(() => {
    // Initialize fbq function
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel after script loads
    script.onload = () => {
      if (window.fbq) {
        window.fbq('init', '431177316638551');
        window.fbq('track', 'PageView');
      }
    };
    // Fallback: initialize immediately if script loads fast
    setTimeout(() => {
      if (window.fbq) {
        window.fbq('init', '431177316638551');
        window.fbq('track', 'PageView');
      }
    }, 100);
  }, []);
  const handlePurchaseClick = () => {
    window.open('https://checkout.ebookditales.com/cart/42817755185215:1', '_blank');
  };
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-gray-800" data-id="element-23">
      <PurchasePopup data-id="element-24" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-purple-50 via-white to-blue-50 pt-6 pb-8 px-4 md:px-8 min-h-screen flex items-center" data-id="element-25">
        <div className="max-w-4xl mx-auto text-center w-full space-y-3 md:space-y-6" data-id="element-26">
          {/* Badge */}
          <div className="inline-block bg-purple-600 text-white px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-wide" data-id="element-27">
            Para Profesionales del TDAH
          </div>

          {/* Title - Short and direct to the pain */}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight px-2 md:px-4" data-id="element-28">
            <span className="text-purple-600" data-id="element-29">DEJÁ DE IMPROVISAR</span>
            <br data-id="element-30" />
            <span className="text-gray-900" data-id="element-31">CADA SESIÓN DE</span>{' '}
            <span className="text-purple-600" data-id="element-32">TDAH</span>
          </h1>

          {/* Product Image - Centered */}
          <div className="py-3 md:py-8 flex justify-center" data-id="element-33">
            <img src={HERO_IMAGE} alt="TDAH Megapack Mockup" className="w-full max-w-[280px] md:max-w-md lg:max-w-lg drop-shadow-2xl hover:scale-105 transition-transform duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-34" />
          </div>

          {/* Subtitle - Below image - Only 2 colors: black and purple */}
          <p className="text-sm md:text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed px-2 md:px-4" data-id="element-35">
            <span className="font-bold text-purple-600" data-id="element-36">Ahorra horas</span> cada
            semana con un{' '}
            <span className="font-bold text-purple-600" data-id="element-37">
              sistema profesional en PDF
            </span>
            , listo para sostener{' '}
            <span className="font-bold text-purple-600" data-id="element-38">
              6 meses de sesiones con TDAH
            </span>{' '}
            sin improvisar.
          </p>

          {/* CTA Button - Below subtitle */}
          <div className="pt-3 md:pt-6" data-id="element-39">
            <button onClick={handlePurchaseClick} className="block w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg mb-3 cursor-pointer" data-id="element-40">
              Obtener TDAH MEGAPACK ahora
            </button>
          </div>
        </div>
      </header>

      {/* The Problem - CONDENSED */}
      <section className="py-12 px-4 bg-white" data-id="element-41">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-42">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-43">
            El niño llega desbordado. La sesión se desarma en minutos.
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-44">
            <span className="font-bold text-purple-600" data-id="element-45">
              Pensar. Ajustar. Contener. Explicar.
            </span>{' '}
            Semana tras semana,{' '}
            <span className="font-bold" data-id="element-46">sostenés todo vos</span> porque no hay
            un sistema que te respalde cuando el TDAH desordena lo planificado.
          </p>
        </div>
      </section>

      {/* What's Included - CONDENSED */}
      <section className="py-12 px-4 bg-purple-50" data-id="element-47">
        <div className="max-w-4xl mx-auto" data-id="element-48">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-49">
            ¿Qué incluye TDAH MEGAPACK?
          </h2>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-50">
            {['24 sesiones estructuradas paso a paso', 'Banco de actividades por nivel de energía', 'Estrategias para momentos de desborde', 'Guía para acompañar familias', 'Roadmap visual de progreso', 'Herramientas antes, durante y después'].map((item, idx) => <div key={idx} className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-51">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-52" />
                <span className="text-gray-700 font-medium" data-id="element-53">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses - CONDENSED */}
      <section className="py-12 px-4 bg-white" data-id="element-54">
        <div className="max-w-5xl mx-auto" data-id="element-55">
          <div className="text-center mb-8" data-id="element-56">
            <span className="bg-red-500 text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase" data-id="element-57">
              3 Bonos Gratis Hoy
            </span>
          </div>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-58">
            <div className="cursor-pointer" onClick={scrollToPurchase} data-id="element-59">
              <img src={BONUS_1} alt="Roadmap" className="w-full rounded-xl shadow-lg mb-3" data-id="element-60" />
              <h3 className="font-bold text-center text-gray-900" data-id="element-61">
                Roadmap de Progreso
              </h3>
            </div>
            <div className="cursor-pointer" onClick={scrollToPurchase} data-id="element-62">
              <img src={BONUS_2} alt="Guía Padres" className="w-full rounded-xl shadow-lg mb-3" data-id="element-63" />
              <h3 className="font-bold text-center text-gray-900" data-id="element-64">
                Guía para Padres
              </h3>
            </div>
            <div className="cursor-pointer" onClick={scrollToPurchase} data-id="element-65">
              <img src={BONUS_3} alt="Actividades" className="w-full rounded-xl shadow-lg mb-3" data-id="element-66" />
              <h3 className="font-bold text-center text-gray-900" data-id="element-67">
                Banco de Actividades
              </h3>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials - CONDENSED to 3 */}
      <section className="py-12 px-4 bg-blue-50" data-id="element-68">
        <div className="max-w-5xl mx-auto" data-id="element-69">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-70">
            Lo que dicen profesionales como vos
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-71">
            <TestimonialCard name="María González" role="Psicopedagoga" location="Buenos Aires" content="Me dio el orden que necesitaba sin perder flexibilidad. Ya no improviso cada sesión." data-id="element-72" />
            <TestimonialCard name="Laura Martínez" role="Psicóloga Infantil" location="Ciudad de México" content="El banco de actividades por nivel de energía cambió mi forma de trabajar completamente." data-id="element-73" />
            <TestimonialCard name="Carolina Silva" role="Psicopedagoga" location="Santiago" content="Este sistema me devolvió la seguridad en mis intervenciones. Recomendadísimo." data-id="element-74" />
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="purchase-section" className="py-16 px-4 bg-gradient-to-b from-purple-900 to-slate-900 text-white" data-id="element-75">
        <div className="max-w-3xl mx-auto text-center" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-77">
            Accedé ahora a TDAH MEGAPACK
          </h2>
          <p className="text-lg text-purple-200 mb-10" data-id="element-78">
            Sistema completo para 6 meses de sesiones sin improvisar
          </p>

          <div className="bg-white text-gray-900 rounded-2xl p-8 shadow-2xl max-w-md mx-auto" data-id="element-79">
            <div className="mb-6" data-id="element-80">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-81">
                <span className="text-5xl font-bold text-gray-900" data-id="element-82">$19990</span>
              </div>
              <p className="text-green-600 font-semibold" data-id="element-83">
                Pago único - Acceso de por vida
              </p>
            </div>

            <div className="space-y-3 mb-6 text-left text-sm" data-id="element-84">
              <div className="flex items-center gap-2" data-id="element-85">
                <Check size={16} className="text-purple-600" data-id="element-86" />
                <span data-id="element-87">24 sesiones + 3 bonos exclusivos</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-88">
                <Check size={16} className="text-purple-600" data-id="element-89" />
                <span data-id="element-90">Material profesional en PDF</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-91">
                <Check size={16} className="text-purple-600" data-id="element-92" />
                <span data-id="element-93">Acceso inmediato</span>
              </div>
            </div>

            <button onClick={handlePurchaseClick} className="block w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg mb-3 cursor-pointer" data-id="element-94">
              Obtener TDAH MEGAPACK ahora
            </button>

            <p className="text-xs text-gray-400 flex items-center justify-center gap-1" data-id="element-95">
              <ShieldCheck size={12} data-id="element-96" />
              Compra 100% segura
            </p>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-12 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-97">
        <div className="max-w-4xl mx-auto" data-id="element-98">
          <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-8 md:p-10 shadow-lg" data-id="element-99">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8" data-id="element-100">
              {/* Shield Icon */}
              <div className="flex-shrink-0" data-id="element-101">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-green-500 rounded-full flex items-center justify-center shadow-lg" data-id="element-102">
                  <ShieldCheck className="w-12 h-12 md:w-14 md:h-14 text-white" strokeWidth={2.5} data-id="element-103" />
                </div>
              </div>

              {/* Guarantee Text */}
              <div className="flex-1 text-center md:text-left" data-id="element-104">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-105">
                  Garantía de Satisfacción de 7 Días
                </h3>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-106">
                  Estamos tan seguros de que{' '}
                  <span className="font-bold text-purple-600" data-id="element-107">
                    TDAH MEGAPACK
                  </span>{' '}
                  va a transformar tu forma de trabajar que te damos 7 días para
                  probarlo. Si sentís que no te ahorra tiempo o no es lo que
                  esperabas, te devolvemos el 100% de tu dinero. Sin preguntas.{' '}
                  <span className="font-bold text-green-700" data-id="element-108">
                    El riesgo es todo nuestro.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-slate-900 text-slate-500 py-8 px-4 text-center text-xs" data-id="element-109">
        <p data-id="element-110">© 2024 TDAH MEGAPACK. Todos los derechos reservados.</p>
      </footer>
    </div>;
}